module.exports = ".carousel{\r\n    \r\n    width: 80%;\r\n    margin: 0 auto;\r\n   \r\n}\r\n@media screen and (min-width: 1100px){\r\n    .carousel{\r\n    \r\n        width: 80%;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/advertisements/advertisements.component.css
// module id = ./src/app/components/advertisements/advertisements.component.css
// module chunks = main